import { render } from "./AiHeader.vue?vue&type=template&id=7dc0dc80"
import script from "./AiHeader.vue?vue&type=script&lang=js"
export * from "./AiHeader.vue?vue&type=script&lang=js"

import "./AiHeader.vue?vue&type=style&index=0&id=7dc0dc80&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__